<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="2">
						<el-form-item>
							<el-button size="small" @click="clickSanke(true)" :type="isSanke ? 'primary' : ''">散客</el-button>
							<el-button size="small" @click="clickSanke(false)" :type="isSanke ? '' : 'primary'">VIP</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="7" v-if="!isSanke">
						<el-form-item label="顾客" :label-width="'60px'">
							<remoteVipSelect style="width:220px;display: inline-block;" :propsVipInfo="propsVipInfo"
								@getCurVipItem="getCurVipItem"></remoteVipSelect>
							<el-button style="margin-left: 10px;" size="small" type="primary"
								v-if="userInfo._id && (isSanke == false)" @click="dialogState_userInfo = true">详情</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="5" v-if="!isSanke">
						<el-form-item label="宠物" :label-width="'40px'">
							<remotePetSelect style="width:250px" :propsPetList="propsPetList"
								@getCurPetItem="getCurPetItem"></remotePetSelect>
						</el-form-item>
					</el-col>
					<el-col :span="3" v-if="!isSanke">
						<el-form-item label="余额" :label-width="'60px'">
							<el-input v-if="userInfo._id" :value="userInfo.card_info.user_yue" disabled></el-input>
							<el-input v-else :value="''" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="优惠折扣" :label-width="'100px'">
							<!-- <div v-if="userInfo._id">
								<el-input v-if="userInfo.club_card. surplus_day === 0" :value="'不打折'" disabled></el-input>
								<el-input v-if="userInfo.club_card. surplus_day === 1" :value="'9.5折'" disabled></el-input>
								<el-input v-if="userInfo.club_card. surplus_day === 2" :value="'9折'" disabled></el-input>
								<el-input v-if="userInfo.club_card. surplus_day === 3"
									:value="'8.8折' + (userInfo.club_card.old_interest === true ? ' (老会员权益)' : '')"
									disabled></el-input>
								<el-input v-if="userInfo.club_card. surplus_day === 4" :value="'8.5折'" disabled></el-input>
								<el-input v-if="userInfo.club_card. surplus_day === 5" :value="'8折'" disabled></el-input>
							</div>
							<el-input v-else :value="''" disabled></el-input> -->
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="margin-top:15px;">
					<el-col :span="4"
						v-if="this.tableData.length === 0 || (this.tableData.length > 0 && this.tableData[0].huotiType !== 1)">
						<el-form-item label="项目" :label-width="'60px'">
							<el-select class="sousuoInput" v-model="serviceGroupKeyword"
								@visible-change="visibleServiceGroup" @change="changeServiceGroup" filterable remote
								reserve-keyword placeholder="请输入关键字" :remote-method="getServiceGroupList"
								:loading="serviceGroupLoading">
								<el-option v-for="(item, index) in serviceGroupList" :key="'serviceGroupKeyword' + index"
									:value="item">
									{{ item.basic_info.group_name || item.basic_info.product_name }}
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4"
						v-if="this.tableData.length === 0 || (this.tableData.length > 0 && this.tableData[0].huotiType !== 1)"
						style="margin-right: 100px;">
						<el-form-item label="录入条码" :label-width="'80px'">
							<el-input v-model="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput"
								placeholder="请录入条码"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item>
							<el-button style="margin-right: 30px;"
								@click="dialogState_scanningCodeMsg = true">查询条码信息</el-button>
							<el-button @click="dialogState_activityList = true">活动查询</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="margin-top:10px;" v-if="guadanBeizhu">
					<el-col :span="4">
						<el-form-item label="挂单备注 :" :label-width="'80px'">
							{{ guadanBeizhu }}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="pageConBox">
			<shouyinTable :table="tableData" :serviceGroup="serviceGroup_prop" :scanningCodeInput="scanningCodeInput_prop"
				:curPeople="userInfo" :curPet="petInfo" :discountCard="discountCard" @change="changeShouyinTable">
			</shouyinTable>
			<el-row style="padding:20px 0;" v-if="remark">
				<el-col :span="4">
					备注：{{ remark }}
				</el-col>
			</el-row>
		</div>
		<div class="fixedBottom">
			<div>
				<span class="priceItem">
					应付金额：
					<span class="price">￥{{ total.total }}</span>
				</span>
				<span class="priceItem">
					优惠金额：
					<span class="price">￥{{ $public.jian(total.total, total.activity) }}</span>
				</span>
			</div>
			<div>
				<span class="priceItem" style="margin-right: 20px;">
					总计：
					<span class="price">￥{{ total.activity }}</span>
				</span>
				<span>
					<dialogDiscountCard
						v-if="this.tableData.length === 0 || (this.tableData.length > 0 && this.tableData[0].huotiType !== 1)"
						:discountCard="discountCard" :arr="tableData" :userInfo="{ _id: userInfo._id }" @submit="submitCard">
					</dialogDiscountCard>
				</span>
				<el-button style="width:80px;" type="primary" plain @click="openBeizhu">备注</el-button>
				<el-button style="width:80px;" type="primary" plain @click="clickSanke(false)">重置</el-button>
				<el-button style="width:80px;" type="primary" plain @click="openGuadan">挂单</el-button>
				<el-button style="width:80px;" type="primary" plain @click="openJiedan">解单</el-button>
				<el-button style="width:80px;" type="primary" plain @click="submitOrder">结算</el-button>
			</div>
		</div>
		<!-- 备注弹窗 -->
		<el-dialog :title="''" :visible.sync="dialog_beizhu_state" width="500px" :show-close="false">
			<div>
				<div style="display: flex;">
					<div style="line-height: 35px;padding:0 0px 0 20px;">备注：</div>
					<el-input style="width:380px;" type="textarea" rows="5" v-model="remark_pre"
						placeholder="请输入备注"></el-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog_beizhu_close">取 消</el-button>
				<el-button type="primary" @click="dialog_beizhu_submit">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 挂单弹窗 -->
		<el-dialog :title="'挂单'" :visible.sync="guadanState" width="500px" :show-close="false">
			<div>
				<div style="display: flex;">
					<div style="line-height: 35px;padding:0 0px 0 20px;">备注：</div>
					<el-input style="width:380px;" type="textarea" rows="5" v-model="guadanBeizhu"
						placeholder="请输入挂单备注"></el-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="guadanState = false">取 消</el-button>
				<el-button type="primary" @click="dialogGuadanSubmit">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 解单弹窗 -->
		<div class="comp">
			<el-dialog :title="'解单'" :visible.sync="jiedanState" width="1200px">
				<div class="dialog">
					<div class="content" style="padding:0;">
						<el-table :data="guadanList" style="width: 100%;margin-bottom: 20px;">
							<el-table-column prop="memberName" label="姓名" width="200">
							</el-table-column>
							<el-table-column prop="petName" label="宠物" width="200">
							</el-table-column>
							<el-table-column prop="petType" label="品种" width="200">
							</el-table-column>
							<el-table-column prop="totalMoney" label="总价" width="150">
							</el-table-column>
							<el-table-column label="备注">
								<template slot-scope="scope">
									{{ scope.row.remark.split("_explain_")[0] }}
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="挂单时间" width="180">
								<template slot-scope="scope">
									{{ $public.FTime(scope.row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column label="操作" width="150">
								<template slot-scope="scope">
									<el-button @click="jiedan(scope.row)" type="success" size="small">解单</el-button>
									<el-button @click="jiedan_del(scope.row)" type="danger" size="small">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<page :total="page.total" @change="pageChange"></page>
				</div>
			</el-dialog>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<!-- 顾客信息 -->
		<div>
			<dialogUserMsg v-if="dialogState_userInfo" :userId="userInfo._id" @close="dialogState_userInfo = false">
			</dialogUserMsg>
		</div>
		<div style="width:0;height: 0;display: inline-block;" v-if="dialogState_scanningCodeMsg">
			<dialogScanningCodeMsg @close="dialogState_scanningCodeMsg = false"></dialogScanningCodeMsg>
		</div>
		<div style="width:0;height: 0;display: inline-block;" v-if="dialogState_activityList">
			<dialogActivityList @close="dialogState_activityList = false"></dialogActivityList>
		</div>
	</div>
</template>
<script>
import remoteVipSelect from "../../../components/remoteVipSelect.vue"
import remotePetSelect from "../../../components/remotePetSelect.vue"
import dialogSettlement from "../../../components/dialog_settlement.vue"
import dialogScanningCodeMsg from "../../../components/dialog_scanningCodeMsg.vue"
import dialogActivityList from "../../../components/dialog_activityList.vue"
import page from "../../../components/page.vue"
import del from "../../../util/del.js"
import shouyinTable from "./shouyinTable.vue"
import dialogDiscountCard from "../../../components/dialog_discount_card.vue"
import dialogUserMsg from "../../../components/dialog_userMsg.vue"
export default {
	components: { remoteVipSelect, remotePetSelect, dialogSettlement, dialogScanningCodeMsg, dialogActivityList, page, shouyinTable, dialogDiscountCard, dialogUserMsg },
	data() {
		return {
			isSanke: false,

			dialogState_userInfo: false,
			userInfo: {},
			petInfo: {},
			propsVipInfo: {},
			propsPetList: [],

			serviceGroupKeyword: '',
			serviceGroupList: [],
			serviceGroupLoading: false,

			scanningCodeInput: '',
			scanningCodeInput_prop: '',
			serviceGroup_prop: '',

			tableData: [],
			total: {
				total: 0,
				activity: 0,
			},
			// del 对象
			o: null,
			// 结算
			dialogSettlement_state: false,
			// 备注
			dialog_beizhu_state: false,
			remark: '',
			remark_pre: '',
			// 挂单
			guadanBeizhu: '',
			guadanState: false,
			// 解单
			jiedanState: false,
			guadanList: [],
			jiedanItem: {},
			page: {
				page: 1,
				pageSize: 10,
				total: 0
			},
			// 订单
			curOrder: {},
			// 满减券
			discountCard: null,
			// 查询条码信息
			dialogState_scanningCodeMsg: false,
			// 活动查询
			dialogState_activityList: false,
		}
	},
	computed: {

	},
	mounted() {
		this.o = new del();
		if (this.$route.query.from == "huiyuan") {
			this.$util.getVipList(this.$route.query.userId).then(list => {
				let userInfo = list[0]
				this.propsPetList = userInfo;
				this.petInfo = {
					"member_id": userInfo._id,
					"member_name": userInfo.basic_info.nick_name,
					"member_mobile": userInfo.basic_info.user_mobile,
					"member_type": userInfo.basic_info.user_type,
					"member_yue": userInfo.card_info.user_yue,
					"member_zenge": userInfo.card_info.user_zenge,
					"pet_id": userInfo.pets_info[0]._id,
					"pet_name": userInfo.pets_info[0].nick_name,
					"pet_type": userInfo.pets_info[0].type_name,
					"pet_class": userInfo.pets_info[0].class_name,
					"pet_birthday": userInfo.pets_info[0].birth_day,
					"pet_sex": userInfo.pets_info[0].sex,
					"pet_sterilization": userInfo.pets_info[0].sterilization,
					"hs_pet": userInfo.pets_info[0].hs_pet === true ? 1 : 0,
				}
			})
		}
	},
	methods: {
		reset() {
			this.userInfo = {};
			this.petInfo = {};
			this.propsVipInfo = {};
			this.propsPetList = [];
			this.remark = '';
			this.guadanBeizhu = '';
			this.jiedanItem = {};
			this.curOrder = {};
			this.o.init([]);
			this.tableData = [];
			this.total.total = 0;
			this.total.activity = 0;
			this.discountCard = null;
		},
		// 切换散客
		clickSanke(b) {
			this.reset();
			if (b) {
				this.isSanke = true;
				this.userInfo = {
					_id: process.env.VUE_APP_sanke,
					basic_info: {
						user_mobile: '13222222222',
						nick_name: '散客',
					},
					card_info: {
						user_yue: 0,
						user_zenge: 0,
					},
					pets_info: [
						{
							_id: '5f33de81c72c8749e6934115',
							class_name: '',
							nick_name: '散客宠物',
							type_name: '',
							birth_day: '',
							sex: '',
							sterilization: 0,
							status: 1,
						}
					],
					club_card: {
						grades: 0,
					}
				}
				this.petInfo = {
					"member_id": process.env.VUE_APP_sanke,
					"member_name": '散客',
					"member_mobile": '13222222222',
					"member_type": 0,
					"member_yue": 0,
					"member_zenge": 0,
					"pet_id": '5f33de81c72c8749e6934115',
					"pet_name": '散客宠物',
					"pet_type": '',
					"pet_class": '',
					"pet_birthday": '',
					"pet_sex": '',
					"pet_sterilization": 0,
					"hs_pet": 0,
				}
			} else {
				this.isSanke = false;
			}
		},
		// 获取选中的顾客
		getCurVipItem(item) {
			console.log(item, '选中的顾客');
			if (item) {
				this.propsPetList = item;
				this.userInfo = item;
			} else {
				this.propsPetList = [];
				this.userInfo = {};
			}
		},
		// 获取选中的宠物
		getCurPetItem(item) {
			if (item) {
				this.propsVipInfo = item;
				this.petInfo = item;
			} else {
				this.propsVipInfo = {};
				this.petInfo = {};
			}
		},
		// 展开关闭下拉 keyword
		visibleServiceGroup(a) {
			if (a) {
				this.getServiceGroupList('');
			} else {
				this.serviceGroupKeyword = '';
			}
		},
		// 改变服务和套餐
		changeServiceGroup(item) {
			if (this.$public.isNull(this.petInfo.pet_id)) {
				this.$message({
					message: '请选择宠物',
					type: 'error'
				});
				return;
			}
			this.serviceGroup_prop = item;
			this.$nextTick(() => {
				this.serviceGroup_prop = ''
			})

		},
		// 查找条码
		clickScanningCodeInput() {
			if (this.$public.isNull(this.petInfo.pet_id)) {
				this.$message({
					message: '请选择宠物',
					type: 'error'
				});
				return;
			}
			this.scanningCodeInput_prop = this.scanningCodeInput;
			this.$nextTick(() => {
				this.scanningCodeInput = '';
				this.scanningCodeInput_prop = this.scanningCodeInput;
			})
		},
		changeShouyinTable(obj) {
			let { arr, type } = obj;
			console.log(arr, type)
			this.tableData = arr;
			this.o.init(this.tableData)
			this.getTotal()
		},
		getTotal() {
			let arr = this.tableData
			this.total.total = 0;
			this.total.activity = 0;
			for (let i = 0; i < arr.length; i++) {
				this.total.total = this.$public.jia(this.total.total, this.$public.cheng(arr[i].originalPrice, arr[i].num))
				this.total.activity = this.$public.jia(this.total.activity, this.$public.cheng(arr[i].price, arr[i].num))
			}
			let activityTotal = this.total.activity;
			if (this.discountCard !== null) {
				if (this.discountCard.activity_type === 1) { // 满减
					activityTotal = this.$public.jian(activityTotal, this.discountCard.money_reduce);
				} else if (this.discountCard.activity_type === 2) { // 折扣
					let yh = this.$public.cheng(activityTotal, this.$public.jian(1, this.discountCard.rebate));
					if (this.discountCard.rebate_limit > 0) {
						if (yh > this.discountCard.rebate_limit) {
							yh = this.discountCard.rebate_limit
						}
					}
					activityTotal = this.$public.jian(activityTotal, yh);
				}
			}
			this.total.activity = activityTotal;
		},
		// 模糊搜索 服务和商品套餐
		getServiceGroupList(query) {
			let params = {
				"keyword": query, //关键字
			}
			this.serviceGroupLoading = true;
			this.$http.get('/api/Goods/SearchKeyword', params).then(res => {
				this.serviceGroupLoading = false;
				if (res.code == 0) {
					this.serviceGroupList = res.data;
				}
			})
		},
		// 优惠券
		submitCard(card) {
			if (card !== 'close') {
				this.discountCard = card;
				this.getTotal();
			}
		},
		// 创建订单
		submitOrder() {
			let loading = this.$loading()
					if (this.tableData.length == 0) {
						this.$message({
							message: '当前未录入商品',
							type: 'warning'
						});
						loading.close();
						return;
					}
					let noStaff = false
					let orderGoods = [];
					for (let i = 0; i < this.tableData.length; i++) {
						let one = {
							"goodsId": this.tableData[i].goodsId,          // 销售对象id
							"goodsName": this.tableData[i].goodsName,        // 销售对象名字
							"goodsType": this.tableData[i].goodsType,               // 1:商品；2:服务；3:套餐；
							"skus": this.tableData[i].skus,
							"skuValue": this.tableData[i].skuValue,
							"unit": this.tableData[i].unit,
							"barCode": this.tableData[i].eprom_no, // 条码
							"originalPrice": this.tableData[i].originalPrice,
							"price": this.tableData[i].price,
							"num": parseInt(this.tableData[i].num),
							"activityId": this.tableData[i].activityId,
							"activityName": this.tableData[i].activityName,
							"totalMoney": this.$public.toDoubleFixed2(Number(this.tableData[i].price) * Number(this.tableData[i].num)),
							"salesMans": this.tableData[i].salesMans,
							"goodsSalesModel": this.tableData[i].gift == 'gift' ? 2 : 1,          // 商品销售模式 1：正常销售；2：赠品
						}
						// for (let a = 0; a < this.tableData[i].goodsList.length; a++) {
						// 	let two = {
						// 		"goodsId": this.tableData[i].goodsList[a].goodsId,      // 商品id
						// 		"goodsName": this.tableData[i].goodsList[a].goodsName,    // 商品名称
						// 		"barCode": this.tableData[i].goodsList[a].eprom_no, // 条码
						// 		"specificationPrice": 0,  // 商品规格单价
						// 		"price": this.tableData[i].goodsList[a].price,               // 销售价格
						// 		"skus": this.tableData[i].skus,
						// 		"skuValue": this.tableData[i].skuValue,
						// 		"model": this.tableData[i].goodsList[a].skus_type,        // 商品规格
						// 		"unit": this.tableData[i].goodsList[a].unit,
						// 		"expiryDate": this.tableData[i].goodsList[a].validityStopDate     // 有效期
						// 	}
						// 	one.goodsList.push(two);
						// }
						if (this.tableData[i].staff.length == 0) {
							noStaff = true
						}
						orderGoods.push(one);
					}
					if (noStaff) {
						this.$message({
							message: '请选择销售人员',
							type: 'error'
						});
						loading.close();
						return;
					}
					let memberId = this.petInfo.member_id;
					let memberName = this.petInfo.member_name;
					let memberMobile = this.petInfo.member_mobile;
					let petId = this.petInfo.pet_id;
					let petName = this.petInfo.pet_name;
					let params = {
						"waitingPayOrderId": 0, // 待支付订单记录id
						"memberId": memberId,
						"memberName": memberName,
						memberMobile: memberMobile,
						"petId": petId,
						"petName": petName,
						"totalMoney": this.$public.toDoubleFixed2(this.totalMoney),
						"discountMoney": 0,
						"remark": this.remark,      // 订单备注
						coupon_no: this.discountCard !== null ? this.discountCard._no : '',
						"orderGoods": orderGoods,
						"sale_pet_info": []
					}
					params.sale_pet_info.push(this.petInfo.pet_sex, this.petInfo.pet_age, String(this.petInfo.create_day))
					console.log(params.sale_pet_info, params)
					if (this.tableData[0].huotiType === 1) {
						this.$http.post('/api/Order/CreateLivingOrder', params).then(res => {
							if (res.code == 0) {
								this.curOrder = res.data;
								this.dialogSettlement_state = true;
								loading.close();
								this.guadanBeizhu = '';
								if (this.jiedanItem.recordId) {
									if (this.jiedanItem.memberId === process.env.VUE_APP_sanke && memberId == process.env.VUE_APP_sanke) {
										this.$confirm('当前是解单状态，是否删除本次被解单前的挂单信息？', '警告', {
											confirmButtonText: '是',
											cancelButtonText: '否',
											type: 'warning'
										}).then(() => {
											this.delGuadan(this.jiedanItem)
											this.jiedanItem = {}
										}).catch(() => {
											this.jiedanItem = {}
										})
									} else {
										console.log(memberId, petId, this.jiedanItem)
										if (this.jiedanItem.memberId === memberId && this.jiedanItem.petId === petId) {
											this.delGuadan(this.jiedanItem)
											this.jiedanItem = {}
										}
									}
								}
							} else {
								loading.close();
							}
						})
					} else {
						this.$http.post('/api/Order/CreateOrder', params).then(res => {
							if (res.code == 0) {
								this.curOrder = res.data;
								this.dialogSettlement_state = true;
								loading.close();
								this.guadanBeizhu = '';
								if (this.jiedanItem.recordId) {
									if (this.jiedanItem.memberId === process.env.VUE_APP_sanke && memberId == process.env.VUE_APP_sanke) {
										this.$confirm('当前是解单状态，是否删除本次被解单前的挂单信息？', '警告', {
											confirmButtonText: '是',
											cancelButtonText: '否',
											type: 'warning'
										}).then(() => {
											this.delGuadan(this.jiedanItem)
											this.jiedanItem = {}
										}).catch(() => {
											this.jiedanItem = {}
										})
									} else {
										console.log(memberId, petId, this.jiedanItem)
										if (this.jiedanItem.memberId === memberId && this.jiedanItem.petId === petId) {
											this.delGuadan(this.jiedanItem)
											this.jiedanItem = {}
										}
									}
								}
							} else {
								loading.close();
							}
						})
					}
				
		
		},
		// 结算完成关闭弹窗
		dialogSettlementSubmit(a) {
			this.dialogSettlement_state = false;
			this.isSanke = false;
			this.userInfo = {};
			this.petInfo = {};
			this.propsVipInfo = {};
			this.propsPetList = [];

			this.tableData = [];
			this.totalMoney = 0;
			this.discountCard = null;
			this.o.init(this.tableData)
			if (a == 'close') {
				if (this.from == 'orderPre') {
					this.$router.replace({ path: "/order/orderList" })
				} else if (this.from == "self") {
					console.log('cancel')
				}
			} else if (a == 'fail') {
				if (this.from == 'orderPre') {
					this.$router.replace({ path: "/order/orderList" })
				} else if (this.from == "self") {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}
			} else if (a == 'success') {
				this.$message({
					message: '结算成功',
					type: 'success'
				});
				if (this.from == 'orderPre') {
					this.$router.back();
				} else if (this.from == "self") {
					this.clearTableData();
				}
			}
		},
		// 备注
		openBeizhu() {
			this.dialog_beizhu_state = true;
			this.remark_pre = this.remark;
		},
		dialog_beizhu_close() {
			this.dialog_beizhu_state = false;
			this.remark_pre = ''
		},
		dialog_beizhu_submit() {
			this.dialog_beizhu_state = false;
			this.remark = this.remark_pre;
			this.remark_pre = ''
		},
		// 打开挂单
		openGuadan() {
			if (this.tableData.length > 0) {
				this.guadanState = true;
			} else {
				this.$message({
					message: '请添加商品',
					type: 'error'
				});
			}
		},
		// 提交挂单
		dialogGuadanSubmit() {
			let params = {
				"memberId": this.petInfo.member_id,
				"memberName": this.petInfo.member_name,
				"petId": this.petInfo.pet_id,
				"petName": this.petInfo.pet_name,
				"petType": this.petInfo.pet_type,
				"totalMoney": this.total.activity,
				"remark": this.guadanBeizhu + '_explain_' + this.remark,
				"orderContent": JSON.stringify(this.tableData),
				couponContent: JSON.stringify(this.discountCard),
			}
			let loading = this.$loading()
			this.$http.post('/api/HandOrder/Insert', params).then(r => {
				loading.close()
				if (r.code == 0) {
					this.guadanState = false;
					this.$message({
						message: '已挂单',
						type: 'success'
					});
					if (this.jiedanItem.recordId) {
						if (this.jiedanItem.memberId === process.env.VUE_APP_sanke && this.petInfo.member_id === process.env.VUE_APP_sanke) {
							this.$confirm('当前是解单状态，是否覆盖本次被解单前的挂单信息？', '警告', {
								confirmButtonText: '是',
								cancelButtonText: '否',
								type: 'warning'
							}).then(() => {
								this.delGuadan(this.jiedanItem)
								this.clickSanke(true)
							}).catch(() => {
								this.clickSanke(true)
							})
						} else {
							if (this.jiedanItem.memberId === this.petInfo.member_id && this.jiedanItem.petId === this.petInfo.pet_id) {
								this.delGuadan(this.jiedanItem)
								this.clickSanke(true)
							} else {
								this.clickSanke(true)
							}
						}
					} else {
						this.clickSanke(true)
					}
				}
			})
		},
		// 页码改变
		pageChange(a) {
			this.page.page = a;
			this.getGuadanList();
		},
		// 获取解单列表
		getGuadanList() {
			let params = {
				"keyword": '',
				"pageIndex": this.page.page,
				"pageSize": this.page.pageSize,
			}
			this.$http.get('/api/HandOrder/List', params).then(res => {
				if (res.code == 0) {
					this.guadanList = res.data.data;
					this.page.total = res.data.count;
				}
			})
		},
		openJiedan() {
			if (this.tableData.length > 0) {
				this.$message({
					message: '当前已录入商品，请先挂单',
					type: 'warning'
				});
				return;
			}
			this.jiedanState = true;
			this.jiedanItem = {}
			this.getGuadanList();
		},
		openSettlement() {
			this.settlementState = true;
		},
		// 解单
		jiedan(row) {
			if (row.memberName == '散客') {
				this.clickSanke(true)
			} else {
				this.clickSanke(false)
			}
			this.$util.getVipList(row.memberId).then(list => {
				this.userInfo = list[0]
			})
			this.$util.getPetList(row.petId).then(list => {
				this.petInfo = list[0]
				this.propsVipInfo = list[0]
			})
			this.guadanBeizhu = row.remark.split('_explain_')[0];
			this.remark = row.remark.split('_explain_')[1];
			this.tableData = JSON.parse(row.orderContent);
			this.o.init(this.tableData);
			this.discountCard = JSON.parse(row.couponContent);
			// 				this.discountCard = {
			// "_id":"5ffe96288170595d43188126",
			// "coupon_id":"5fae44035e7314393508f21e",
			// "coupon_name":"满200减100",
			// "_no":"101458",
			// "member_id":"5fe0425dc72c8752b1cbab18",
			// "member_name":"测试",
			// "member_mobile":"19103816302",
			// "use_shop":null,
			// "use_shop_id":null,
			// "use_status":1,
			// "use_scene":2,
			// "receive_time":"1610520104",
			// "use_time":null,
			// "use_start_time":"1605456000",
			// "use_end_time":"1640880000",
			// "money_top":200,
			// "money_reduce":100,
			// "due_amount":0,
			// "actual_amount":0,
			// "activity_type":1,
			// "rebate":0,
			// "rebate_top":0,
			// "rebate_limit":0,
			// "coupon_type":4,
			// "order_no":null
			// }
			this.jiedanItem = row;
			this.jiedanState = false;
			this.getTotal()
		},
		jiedan_del(row) {
			this.$confirm('确定要删除?', '警告', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.delGuadan(row, 'refresh');
			})
		},
		// 删除 挂单
		delGuadan(row, type) {
			let params = {
				"hangOrderId": row.recordId,
			}
			this.$http.delete('/api/HandOrder/Delete', params).then(res => {
				console.log('删除挂单', res)
				if (type === 'refresh') {
					this.getGuadanList();
				}
			})
		},
	}
}
</script>
<style scoped lang="scss">
.page {
	padding-bottom: 85px;
	position: relative;

	.searchBox {
		padding: 20px;
		border-radius: 6px;
		height: auto;

		.el-form-item {
			margin-bottom: 0;
		}
	}

	.pageConBox {
		padding: 0 20px;
		min-height: 300px;
		margin-top: 10px;
	}

	.fixedBottom {
		padding-left: 220px;
		width: 100%;
		position: fixed;
		height: 80px;
		z-index: 2;
		bottom: 0;
		left: 0;
		text-align: right;
		box-sizing: border-box;
		margin-bottom: 0;
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		padding: 15px 30px 15px 220px;

		.priceItem {
			font-size: 16px;
			color: #1a1a1a;
			padding: 12px 20px 0 20px;
			display: inline-block;

			.price {
				font-size: 30px;
				vertical-align: sub;
			}
		}
	}
}</style>
